/* =========================================
 * FILE: assets/boton-compra-anclado.js
 * Impulse 7.1.0 — COMPLETO (TOP EXACTO al final del header + FULL WIDTH)
 *
 * - Desktop: top = header.getBoundingClientRect().bottom (pegado al final visible)
 * - Recalcula con ResizeObserver + scroll (con RAF) + resize + section load
 * - Footer detection Impulse + fallback scroll/resize
 * - requestSubmit (Impulse)
 * - Buy Now auto + hide on validation errors
 * - Sync qty + selling_plan + properties[...]
 * ========================================= */

/* =========================================
 * FILE: assets/boton-compra-anclado.js
 * Impulse 7.1.0 — COMPLETO (debajo del header REAL + full width)
 * ========================================= */

(() => {
  const root = document.querySelector("[data-bca]");
  if (!root) return;

  const isProductPage =
    document.body.classList.contains("template-product") ||
    document.body.classList.contains("template-product-main") ||
    window.location.pathname.includes("/products/");
  if (!isProductPage) return;

  const showQty = root.dataset.showQty === "true";
  const showPlan = root.dataset.showPlan === "true";
  const showBuyNowSetting = root.dataset.showBuyNow === "true";

  const els = {
    btn: root.querySelector("[data-bca-btn]"),
    buyNow: root.querySelector("[data-bca-buy-now]"),
    qty: root.querySelector("[data-bca-qty]"),
    plan: root.querySelector("[data-bca-plan]"),
  };

  const state = {
    footerInView: false,
    ctaInView: true,
    currentVariantId: String(root.dataset.initialVariantId || ""),
    buyNowAvailable: false,
    hasValidationError: false,
  };

  const BCA_PROP_ATTR = "data-bca-prop";

  const isElementVisible = (el) => {
    if (!el) return false;
    const cs = getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden" || cs.opacity === "0") return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  };

  /* ---------------------------------
   * ✅ HEADER: calcular “stack” real sticky/fixed
   * --------------------------------- */
  const getHeaderStackTop = () => {
    // Lista de candidatos típicos Impulse
    const candidates = [
      "#shopify-section-announcement-bar",
      "[data-section-type*='announcement']",
      ".announcement-bar",
      "#shopify-section-header",
      "[role='banner']",
      "header",
      ".header",
      ".site-header",
      ".header-wrapper",
      ".header__wrapper",
      ".header-sticky-wrapper",
    ];

    const nodes = [];
    candidates.forEach((sel) => {
      document.querySelectorAll(sel).forEach((n) => nodes.push(n));
    });

    // Dedupe
    const uniq = Array.from(new Set(nodes)).filter((n) => n && isElementVisible(n));

    // Qué elementos cuentan como “header fijo”
    const fixedOrStickyAtTop = uniq.filter((n) => {
      const cs = getComputedStyle(n);
      if (cs.position !== "fixed" && cs.position !== "sticky") return false;
      // si sticky/fixed no está “arriba”, no cuenta
      const top = parseFloat(cs.top || "0");
      return Number.isFinite(top) ? top <= 5 : true;
    });

    // Si no detecta nada fixed/sticky, usa el header normal
    const list = fixedOrStickyAtTop.length ? fixedOrStickyAtTop : uniq;

    let maxBottom = 0;
    list.forEach((n) => {
      const r = n.getBoundingClientRect();
      if (r.bottom > maxBottom) maxBottom = r.bottom;
    });

    return Math.max(0, Math.round(maxBottom));
  };

  const setStickyUnderHeaderDesktop = () => {
    if (window.matchMedia("(max-width: 989px)").matches) return;
    const top = getHeaderStackTop();
    // +1px para evitar “hairline overlap”
    root.style.setProperty("--bca-desktop-top-offset", `${top + 1}px`);
  };

  const observeHeader = () => {
    if (typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver(() => setStickyUnderHeaderDesktop());

    // Observa todo lo que parezca header/announcement
    const sels = [
      "#shopify-section-announcement-bar",
      "#shopify-section-header",
      "[role='banner']",
      "header",
    ];
    sels.forEach((sel) => {
      document.querySelectorAll(sel).forEach((n) => {
        try { ro.observe(n); } catch (e) {}
      });
    });
  };

  /* ---------------------------------
   * Footer
   * --------------------------------- */
  const findFooter = () => {
    return (
      document.querySelector("footer") ||
      document.querySelector("[role='contentinfo']") ||
      document.querySelector("[data-section-type='footer']") ||
      document.querySelector("[id*='__footer']") ||
      document.querySelector(".footer") ||
      document.querySelector("[class*='footer']")
    );
  };

  /* ---------------------------------
   * Form selection (avoid quick add)
   * --------------------------------- */
  const findProductForm = () => {
    const main = document.querySelector("#MainContent") || document.querySelector("main") || document;

    const pf = main.querySelector("product-form form[action*='/cart/add']");
    if (pf) return pf;

    const forms = Array.from(main.querySelectorAll("form[action*='/cart/add']"));
    if (forms.length === 1) return forms[0];

    const primary =
      forms.find((f) => f.closest("[data-section-type='main-product'], .product-section, .product, .product__info")) ||
      forms.find((f) => f.closest("#MainContent")) ||
      forms[0];

    return primary || null;
  };

  const findPrimaryCta = () => {
    const form = findProductForm();
    if (!form) return null;

    const candidates = [
      "button[type='submit']",
      "button[name='add']",
      ".product-form__submit",
      ".add-to-cart",
      ".btn--add-to-cart",
      "[data-add-to-cart]",
    ];

    for (const sel of candidates) {
      const el = form.querySelector(sel);
      if (el) return el;
    }
    return null;
  };

  const findBuyNowButton = () => {
    const form = findProductForm();
    if (!form) return null;

    const candidates = [
      ".shopify-payment-button__button",
      "button[name='buy_now']",
      "[data-shopify-payment-button] button",
      ".shopify-payment-button button",
    ];

    for (const sel of candidates) {
      const el = form.querySelector(sel);
      if (el) return el;
    }
    return null;
  };

  /* ---------------------------------
   * Validation => hide buy now
   * --------------------------------- */
  const hasDomErrorIndicators = (form) => {
    if (!form) return false;

    const candidates = [
      ".product-form__error-message-wrapper",
      ".product-form__error-message",
      ".form__message",
      ".errors",
      ".error",
      "[data-error]",
      "[aria-invalid='true']",
      ".field--error",
      ".is-error",
      ".has-error",
    ];

    for (const sel of candidates) {
      const nodes = Array.from(form.querySelectorAll(sel));
      if (nodes.some((n) => isElementVisible(n) && String(n.textContent || "").trim().length > 0)) return true;
    }

    return Boolean(form.querySelector("[aria-invalid='true']"));
  };

  const validateFormOrFlag = (form) => {
    if (!form) return true;

    if (typeof form.checkValidity === "function" && !form.checkValidity()) {
      state.hasValidationError = true;
      if (typeof form.reportValidity === "function") form.reportValidity();
      return false;
    }

    if (hasDomErrorIndicators(form)) {
      state.hasValidationError = true;
      return false;
    }

    state.hasValidationError = false;
    return true;
  };

  const refreshBuyNowVisibility = () => {
    if (!els.buyNow) return;

    if (!showBuyNowSetting || state.hasValidationError) {
      els.buyNow.hidden = true;
      state.buyNowAvailable = false;
      return;
    }

    const real = findBuyNowButton();
    const canUse = Boolean(real) && !real.disabled && isElementVisible(real);

    state.buyNowAvailable = canUse;
    els.buyNow.hidden = !canUse;
  };

  /* ---------------------------------
   * qty / plan
   * --------------------------------- */
  const getVariantIdFromForm = (form) => {
    const idInput = form?.querySelector("[name='id']");
    if (idInput?.value) return String(idInput.value);
    return state.currentVariantId;
  };

  const setQuantityInForm = (form, value) => {
    const qty = form?.querySelector("[name='quantity']");
    if (!qty) return;
    qty.value = String(value);
    qty.dispatchEvent(new Event("change", { bubbles: true }));
    qty.dispatchEvent(new Event("input", { bubbles: true }));
  };

  const setSellingPlanInForm = (form, value) => {
    const sp = form?.querySelector("[name='selling_plan']");
    if (!sp) return;
    sp.value = String(value || "");
    sp.dispatchEvent(new Event("change", { bubbles: true }));
  };

  /* ---------------------------------
   * properties[...]
   * --------------------------------- */
  const cleanupInjectedProperties = (form) => {
    if (!form) return;
    form.querySelectorAll(`[${BCA_PROP_ATTR}]`).forEach((n) => n.remove());
  };

  const getPropertyPairsFromElement = (el) => {
    const name = el.getAttribute("name") || "";
    if (!name.startsWith("properties[")) return [];
    if (el.disabled) return [];

    const type = (el.getAttribute("type") || "").toLowerCase();
    const tag = (el.tagName || "").toLowerCase();
    if (type === "file") return [];

    if (type === "checkbox") return el.checked ? [[name, el.value || "on"]] : [];
    if (type === "radio") return el.checked ? [[name, el.value || "on"]] : [];

    if (tag === "select" && el.multiple) {
      const vals = Array.from(el.selectedOptions || []).map((o) => o.value).filter(Boolean);
      return vals.length ? [[name, vals.join(", ")]] : [];
    }

    const val = (el.value ?? "").toString();
    return val ? [[name, val]] : [];
  };

  const collectLineItemProperties = (form) => {
    const container =
      form.closest("[data-section-type='main-product']") ||
      form.closest(".product-section") ||
      document.querySelector("#MainContent") ||
      document;

    const all = Array.from(
      container.querySelectorAll(
        "input[name^='properties['], select[name^='properties['], textarea[name^='properties[']"
      )
    );

    const map = new Map();
    for (const el of all) {
      const pairs = getPropertyPairsFromElement(el);
      for (const [k, v] of pairs) if (v && v.trim()) map.set(k, v);
    }
    return Array.from(map.entries());
  };

  const injectLineItemPropertiesIntoForm = (form) => {
    if (!form) return;

    cleanupInjectedProperties(form);

    const pairs = collectLineItemProperties(form);

    for (const [name, value] of pairs) {
      const existing = form.querySelector(`[name="${CSS.escape(name)}"]`);
      if (existing && !existing.disabled) continue;

      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      input.setAttribute(BCA_PROP_ATTR, "1");
      form.appendChild(input);
    }
  };

  /* ---------------------------------
   * Sticky show/hide
   * --------------------------------- */
  const setVisible = () => {
    const shouldShow = !state.footerInView && !state.ctaInView;
    root.classList.toggle("is-visible", shouldShow);
    root.setAttribute("aria-hidden", shouldShow ? "false" : "true");
    if (shouldShow) setStickyUnderHeaderDesktop();
  };

  /* ---------------------------------
   * Submit (Impulse)
   * --------------------------------- */
  const requestSubmitSafe = (form, submitButton) => {
    if (!form) return;
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit(submitButton || undefined);
      return;
    }
    if (submitButton?.click) submitButton.click();
    else form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
  };

  const syncToFormBeforeAction = () => {
    const form = findProductForm();
    if (!form) return { ok: false, form: null };

    const idInput = form.querySelector("[name='id']");
    const variantId = getVariantIdFromForm(form);

    if (idInput && variantId) {
      idInput.value = String(variantId);
      idInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    if (showQty && els.qty) {
      const val = Math.max(1, Number(els.qty.value || 1));
      setQuantityInForm(form, val);
    }

    if (showPlan && els.plan && !els.plan.hidden) {
      setSellingPlanInForm(form, els.plan.value);
    }

    injectLineItemPropertiesIntoForm(form);

    const ok = validateFormOrFlag(form);
    refreshBuyNowVisibility();
    setStickyUnderHeaderDesktop();
    return { ok, form };
  };

  const onAddToCartClick = () => {
    const submit = findPrimaryCta();
    const { ok, form } = syncToFormBeforeAction();
    if (!ok || !form || !submit) return;
    requestSubmitSafe(form, submit);
  };

  const onBuyNowClick = () => {
    if (!state.buyNowAvailable) return;
    const real = findBuyNowButton();
    const { ok } = syncToFormBeforeAction();
    if (!ok || !real) return;
    real.click();
  };

  /* ---------------------------------
   * Observers
   * --------------------------------- */
  const observeCtaVisibility = () => {
    const cta = findPrimaryCta();
    if (!cta) {
      state.ctaInView = false;
      setVisible();
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        state.ctaInView = entries.some((x) => x.isIntersecting);
        setVisible();
      },
      { threshold: 0.15 }
    );
    io.observe(cta);
  };

  const observeFooterVisibility = () => {
    const footer = findFooter();
    if (!footer) return;

    const io = new IntersectionObserver(
      (entries) => {
        state.footerInView = entries.some((x) => x.isIntersecting);
        setVisible();
      },
      { threshold: 0.01 }
    );
    io.observe(footer);

    const onScroll = () => {
      const r = footer.getBoundingClientRect();
      state.footerInView = r.top < window.innerHeight && r.bottom > 0;
      setVisible();
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();
  };

  const observeFormMutations = () => {
    const form = findProductForm();
    if (!form) return;

    const mo = new MutationObserver(() => {
      validateFormOrFlag(form);
      injectLineItemPropertiesIntoForm(form);
      refreshBuyNowVisibility();
      setStickyUnderHeaderDesktop();
    });
    mo.observe(form, { childList: true, subtree: true, attributes: true, characterData: true });
  };

  /* ---------------------------------
   * Bindings
   * --------------------------------- */
  const bindStickyControlEvents = () => {
    const form = findProductForm();
    if (!form) return;

    if (showQty && els.qty) {
      els.qty.addEventListener("change", () => {
        const val = Math.max(1, Number(els.qty.value || 1));
        els.qty.value = String(val);
        setQuantityInForm(form, val);
        injectLineItemPropertiesIntoForm(form);
        validateFormOrFlag(form);
        refreshBuyNowVisibility();
        setStickyUnderHeaderDesktop();
      });
    }

    if (showPlan && els.plan) {
      els.plan.addEventListener("change", () => {
        setSellingPlanInForm(form, els.plan.value);
        injectLineItemPropertiesIntoForm(form);
        validateFormOrFlag(form);
        refreshBuyNowVisibility();
        setStickyUnderHeaderDesktop();
      });
    }
  };

  /* ---------------------------------
   * Init
   * --------------------------------- */
  const init = () => {
    // Header top updates
    setStickyUnderHeaderDesktop();
    observeHeader();

    window.addEventListener("resize", setStickyUnderHeaderDesktop);

    // scroll con RAF (suave)
    let raf = null;
    window.addEventListener(
      "scroll",
      () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          setStickyUnderHeaderDesktop();
          raf = null;
        });
      },
      { passive: true }
    );

    els.btn?.addEventListener("click", onAddToCartClick);
    if (els.buyNow) els.buyNow.addEventListener("click", onBuyNowClick);

    observeCtaVisibility();
    observeFooterVisibility();
    observeFormMutations();
    bindStickyControlEvents();

    refreshBuyNowVisibility();
    setVisible();
  };

  init();
})();